module.exports = __webpack_public_path__ + "img/NScout264_ua.e131889a.webp";